import { createEffect, createEvent, createStore } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { TransactionsApi } from '@shared/api';

export const generateRecipientEffect = createEffect((request: string) => TransactionsApi.getReceipt(request));
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(generateRecipientEffect.pending, (_, data) => data)
  .on(generateRecipientEffect.fail, () => false)
  .on(generateRecipientEffect.done, () => false)
  .reset(clearEvent);

generateRecipientEffect.done.watch((result) => FileUtils.downloadFile(result.result));
generateRecipientEffect.fail.watch(() => $notificationStore.events.setError('Something went wrong while downloading Receipt. Please try again.'));

export const $downloadRecipientStore = {
  events: {
    downloadRecipient: generateRecipientEffect,
    clear: clearEvent,
  },
  store: {
    loading: $loadingStore,
  },
};
